import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Container,
} from "@mui/material";
import partner1 from "../assests/partner1.png";
import partner2 from "../assests/partner2.png";
import partner3 from "../assests/partner3.png";
import partner4 from "../assests/partner4.png";
import partner5 from "../assests/partner5.png";
import partner6 from "../assests/partner6.png";
import { useVendorStore } from '../store/useVendorStore';
import Loader from './Loader/Loader';

export default function OurPartners() {
  const { getAllVendor, vendor, loading } = useVendorStore()

  const getAllVendorFunctioncaller = async () => {
    const data = await getAllVendor(1, 10, '', '')
  }

  useEffect(() => {
    if (vendor.length === 0)
      getAllVendorFunctioncaller()
  }, [])
  return (
    <Box sx={{
      background: "rgba(217, 217, 217, 0.4)",
      padding: "60px 0",
    }}>
      <Loader loading={loading} />
      <Container maxWidth="xl">
        <Typography sx={{
          fontSize: '40px',
          lineHeight: '100%',
          fontWeight: '700',
          fontFamily: `"Quicksand", sans-serif`,
          color: '#253D4E',
          textAlign: "center",
        }}>Our Partners</Typography>
        <Box sx={{
          padding:{ xs:"0px 2% 10px", sm: "60px 10% 30px", md:"60px 10% 30px", lg: "60px 10% 30px"},
          display:{ xs:"block", sm: "flex", md:"flex", lg: "flex"},
          alignItems: "center",
          justifyContent: "space-between",
          "& img": {
            maxWidth: "100%",
            display: "block",
            width: { xs:"60%", sm: "100px", md: "140px", lg: "16%" },
            margin:{xs:"30px 20% 0", sm: "0", md: "0", lg: "0" }
          },
        }}>
          {
            (vendor || []).map((ele, index) => (
              <img key={index} src={ele?.vendorLogo} alt="partner" />
            ))
          }
        </Box>
      </Container>

    </Box>
  )
}
